import { RouterConstants } from '../../../configuration/router.constants';
import { IFramePostMessages } from '../../../models/modules/lotteryplatform-client.models';
import moment from 'moment';
import { LotteryKeyHelper, BundleKeyHelper, SyndicateKeyHelper, InstantGameKeyHelper } from '../../../services/modules/brand-client.service';
import { DrawDateHelper } from '../../../models/modules/draw-date-helper';
import { LotteryHelper } from '../../../views/app/client/utilities/lottery-string-helper';
import * as Enumerable from 'linq';
var BaseTemplate = /** @class */ (function () {
    function BaseTemplate(router, i18n, clientLotteryClientService, dialogClient, tokenClient) {
        this.router = router;
        this.i18n = i18n;
        this.clientLotteryClientService = clientLotteryClientService;
        this.dialogClient = dialogClient;
        this.tokenClient = tokenClient;
        this.lotteries = [];
        this.timeFilters = [
            {
                title: this.i18n.tr("all"),
                dateFrom: null
            },
            {
                title: this.i18n.tr("today"),
                dateFrom: this.getTodaysDate()
            },
            {
                title: this.i18n.tr("yesterday"),
                dateFrom: this.getYesterdaysDate()
            },
            {
                title: this.i18n.tr("last-seven-days"),
                dateFrom: this.getSevenDaysAgoDate()
            },
            {
                title: this.i18n.tr("last-thirty-days"),
                dateFrom: this.getThirtyDaysAgoDate()
            }
        ];
    }
    BaseTemplate.prototype.getThirtyDaysAgoDate = function () {
        var date = new Date();
        date.setDate(date.getDate() - 30);
        return new Date(date.getFullYear(), (date.getMonth() + 1), date.getDate());
    };
    BaseTemplate.prototype.getSevenDaysAgoDate = function () {
        var date = new Date();
        date.setDate(date.getDate() - 7);
        return new Date(date.getFullYear(), (date.getMonth() + 1), date.getDate());
    };
    BaseTemplate.prototype.getYesterdaysDate = function () {
        var date = new Date();
        date.setDate(date.getDate() - 1);
        return new Date(date.getFullYear(), (date.getMonth() + 1), date.getDate());
    };
    BaseTemplate.prototype.getTodaysDate = function () {
        var date = new Date();
        return new Date(date.getFullYear(), (date.getMonth() + 1), date.getDate());
    };
    BaseTemplate.prototype.setSelectedTimeFilter = function (filter) {
        this.currentTimeFilter = filter;
        this.currentTimeFilterChanged();
    };
    BaseTemplate.prototype.currentTimeFilterChanged = function () { };
    BaseTemplate.prototype.activate = function (params) {
        var _this = this;
        this.params = params;
        if (params && params.key)
            this.key = params.key;
        this.isSamePage = params && params.isSamePage;
        this.currentTimeFilter = this.timeFilters[0];
        return new Promise(function (resolve, reject) {
            _this.clientLotteryClientService.getLobbyBrandLotteries({}).then(function (x) {
                _this.lotteries = x;
                _this.onLotteriesLoaded();
                resolve();
            }, function (x) {
                console.log("Error", _this.i18n.tr(x.response));
                _this.onLotteriesLoaded();
                reject();
            });
        });
    };
    BaseTemplate.prototype.getAd = function (key, element) {
        try {
            var value = this.i18n.tr(key);
            if (value.startsWith("http://") || value.startsWith("https://")) {
                // external pages open in new tab   
                if (element)
                    element.setAttribute("target", "_blank");
                return value;
            }
            else if (value.startsWith("lottery/") || value.startsWith("/lottery/")) {
                //lottery/:brandLotteryId/:lotteryId/:key
                var url = value.split("/");
                var lotteryId = url[url.length - 1];
                var lottery = Enumerable.from(this.lotteries).firstOrDefault(function (x) { return x.lotteryId.toString() == lotteryId; });
                return "/client/lottery/" + lottery.brandLotteryId + "/" + lottery.lotteryId + "/" + this.getLotteryKey(lottery.lotteryName);
            }
            else if (value && value.trim().startsWith("/")) {
                return "/client" + value.trim();
            }
            else if (value && value.trim()) {
                return "/client/" + value.trim();
            }
        }
        catch (_a) {
            return "";
        }
        return "";
    };
    BaseTemplate.prototype.attached = function () {
        var _this = this;
        var scrollTop = this.isSamePage ? false : this.shouldScrollTopOnLoad();
        this.interval = setInterval(function () {
            var ele = $(_this.getRouterView())[0];
            if (!ele)
                return;
            var routerHeight = ele.clientHeight;
            var navHeight = $(".common-navigation-menu")[0] ? $(".common-navigation-menu")[0].clientHeight : 0;
            var totalHeight = navHeight + routerHeight;
            if (_this.shouldSendHeightToClient()) {
                if (_this.lastKnownHeight != totalHeight) {
                    _this.lastKnownHeight = totalHeight;
                    _this.sendHeightToClient(totalHeight + "px", scrollTop);
                    scrollTop = false;
                    console.log("iFrame height changed: " + totalHeight);
                }
            }
        }, 250);
    };
    BaseTemplate.prototype.shouldSendHeightToClient = function () {
        return !this.tokenClient.isOverlay && !this.tokenClient.isWidget;
    };
    BaseTemplate.prototype.getRouterView = function () {
        return ".router-view";
    };
    BaseTemplate.prototype.shouldScrollTopOnLoad = function () {
        return true;
    };
    BaseTemplate.prototype.sendHeightToClient = function (num, scrollTop) {
        try {
            window.parent.postMessage({
                event: IFramePostMessages.onIFrameHeightChange,
                detail: {
                    height: num,
                    scrollTop: scrollTop,
                    page: this.getCurrentRoute()
                }
            }, "*");
        }
        catch (e) {
            console.log("failed to send height to client: " + e);
        }
    };
    BaseTemplate.prototype.getCurrentRoute = function () {
        return this.router.currentInstruction && this.router.currentInstruction.config ? this.router.currentInstruction.config.name : "";
    };
    BaseTemplate.prototype.detached = function () {
        if (this.interval)
            clearInterval(this.interval);
    };
    BaseTemplate.prototype.onLotteriesLoaded = function () {
    };
    Object.defineProperty(BaseTemplate.prototype, "size", {
        get: function () {
            if (window.innerWidth >= 1024)
                return 'lg';
            if (window.innerWidth >= 768)
                return 'sm';
            return 'xs';
        },
        enumerable: false,
        configurable: true
    });
    BaseTemplate.prototype.showNotice = function (e) {
        e.classList.add("show");
    };
    BaseTemplate.prototype.navigateToLobby = function () {
        this.router.navigateToRoute(RouterConstants.RouteNames.Lobby);
    };
    BaseTemplate.prototype.navigateToResults = function () {
        this.router.navigateToRoute(RouterConstants.RouteNames.Results);
    };
    BaseTemplate.prototype.getBundleKey = function (name) {
        var key = name ? BundleKeyHelper.getKey(name) : '';
        return key;
    };
    BaseTemplate.prototype.getSyndicateKey = function (name) {
        var key = name ? SyndicateKeyHelper.getKey(name) : '';
        return key;
    };
    BaseTemplate.prototype.getLotteryKey = function (name) {
        var key = name ? LotteryKeyHelper.getKey(name) : '';
        return key;
    };
    BaseTemplate.prototype.getInstantGameKey = function (name) {
        var key = name ? InstantGameKeyHelper.getKey(name) : '';
        return key;
    };
    BaseTemplate.prototype.getNextDraw = function (lottery) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!lottery) {
                resolve("");
            }
            else {
                //updated to return the closing date 
                var text = _this.getNextDrawText(lottery.closingDateTime);
                if (text === '' || text == 'Pending') {
                    var calculatedDate = DrawDateHelper.calculateNextDrawDate(lottery.isCustom, 2, false, lottery.sunday, lottery.monday, lottery.tuesday, lottery.wednesday, lottery.thursday, lottery.friday, lottery.saturday, lottery.drawDate, lottery.ticketSalesClosingTime);
                    var drawTimeDate = new Date(lottery.ticketSalesClosingTime);
                    calculatedDate.setHours(drawTimeDate.getHours());
                    calculatedDate.setMinutes(drawTimeDate.getMinutes());
                    text = _this.getNextDrawText(calculatedDate);
                    resolve(text);
                }
                else {
                    resolve(text);
                }
            }
        });
    };
    BaseTemplate.prototype.getNextDrawText = function (drawDate) {
        if (!drawDate)
            return '';
        var str = '';
        var remaining = this.getTimeRemaining(drawDate);
        var dayStr = 'day ';
        var daysStr = 'days ';
        var hourStr = 'hr ';
        var hoursStr = 'hrs ';
        var minuteStr = 'min ';
        var minutesStr = 'mins ';
        str += this.humanizeString(remaining.days, dayStr, daysStr);
        str += this.humanizeString(remaining.hours, hourStr, hoursStr);
        str += this.humanizeString(remaining.minutes, minuteStr, minutesStr);
        if (str === '') {
            return this.i18n.tr('Pending');
        }
        return str;
    };
    BaseTemplate.prototype.humanizeString = function (remaining, single, plural) {
        var str = '';
        if (remaining) {
            if (remaining == 1) {
                str += remaining + single;
            }
            else if (remaining > 1) {
                str += remaining + plural;
            }
        }
        return str;
    };
    BaseTemplate.prototype.getTimeRemaining = function (drawDate) {
        var drawTime = moment.utc(drawDate, 'YYYY-MM-DD HH:mm');
        var local = drawTime.local();
        //set draw time to lottery draw date
        var dateWithDrawTime = new Date(drawDate);
        if (local) {
            dateWithDrawTime.setHours(local.hours());
            dateWithDrawTime.setMinutes(local.minutes());
        }
        //let t = Date.parse(dateWithDrawTime) - Date.parse(new Date());
        var t = new Date(dateWithDrawTime).getTime() - new Date().getTime();
        var seconds = Math.floor((t / 1000) % 60);
        var minutes = Math.floor((t / 1000 / 60) % 60);
        var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
            'total': t,
            'days': days,
            'hours': hours,
            'minutes': minutes,
            'seconds': seconds
        };
    };
    BaseTemplate.prototype.getLotteryByKey = function (lotteries, key) {
        return LotteryHelper.getLotteryByKey(lotteries, key);
    };
    return BaseTemplate;
}());
export { BaseTemplate };
